// extracted by mini-css-extract-plugin
export default {"menu":"MobileMenu_menu__MhBDt","container":"MobileMenu_container__S8Oqw","list":"MobileMenu_list__17D24","item":"MobileMenu_item__5fFCM","menu_close":"MobileMenu_menu_close__Sw8-8"};